<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-card title="서명란" ref="card" class="cardClassDetailInfo" topClass="topcolor-orange">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn v-if="popupParam.hcfSelfCheckCompleteFlag !== 'Y'" label="적용" color="blue" :showLoading="false" @btnClicked="saveAsSvg" />
            <c-btn v-if="popupParam.hcfSelfCheckCompleteFlag !== 'Y'" label="지우기" color="red" :showLoading="false" @btnClicked="eraseSignature" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12">
            <div class="container">
              <div class="row items-center all-pointer-events">
                <b>
                  <font id="signatureContent">&nbsp;&nbsp; [ 이름을 정자로 입력하세요. ]</font>
                </b>
              </div>
              <VueSignaturePad id="signature"  :width="windowWidth" height="200px" ref="signaturePad"/>
            </div>
          </div>
        </template>
      </c-card>
    </div>
  </div>
</template>
<script>
import VueSignaturePad from 'vue-signature-pad';
import Vue from 'vue';
let signaturePad = null;
Vue.use(VueSignaturePad)
export default {
  name: 'hazard-facility-self-check-signature',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          hcfHazardFacilitySelfCheckId: '',
          electronSignature: '',
          hcfSelfCheckCompleteFlag: '',
        }
      },
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    window.addEventListener('resize', this.setSize);
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setSize);
  },
  computed: {
    windowWidth() {
      return (window.innerWidth - 60) + 'px'
    }
  },
  watch: {
  },
  methods: {
    init() {
      if (!this.$refs.signaturePad) {
        return;
      }
      signaturePad = this.$refs.signaturePad
      

      console.log(this.$refs.signaturePad)
      if (this.popupParam.hcfSelfCheckCompleteFlag === 'Y') {
        signaturePad.lockSignaturePad();
      }

      if (this.popupParam.electronSignature) {
        signaturePad.fromDataURL(this.popupParam.electronSignature);
      }

    },
    saveAsSvg() {
      var data = ''
      if (signaturePad.saveSignature().isEmpty) {
        data = ''
      } else {
        data = signaturePad.saveSignature().data;
      }
      this.popupParam.electronSignature = data;
      
      if (!this.popupParam.electronSignature) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '서명하세요.', // 서명하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', {
          electronSignature: this.popupParam.electronSignature
        });
      }
    },
    setSize() {
      signaturePad.fromDataURL(this.popupParam.electronSignature);
    },
    eraseSignature() {
      signaturePad.clearSignature();
      this.popupParam.electronSignature = '';
    },
    reset() {
      Object.assign(this.$data.info, this.$options.data().info);
    },
  }
};
</script>
<style>
#signature {
  border: double 1px transparent;
  border-radius: 2;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #000000, #000000);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
.container {
  width: "100%";
  /* margin-top: 5px !important; */
  margin-bottom: 20px !important;
  padding: 0px 8px 0px 2px
}
</style>